export const APP_STATUS = {
  ACTIVE: "active",
  IDLE: "idle",
} as const

export type AppStatus = typeof APP_STATUS[keyof typeof APP_STATUS]

export const homeScreenModeWithElectron = (enable: boolean = true) => {
  if (!window.electron) return

  window.electron.sendMessage("setHomeScreenMode", { enable })
}

export const updateAppStatus = (status: AppStatus) => {
  if (!window.electron) return

  window.electron.sendMessage("updateAppStatus", { status })
}

export const homeScreenModeWebApp = (enable: boolean = true) => {
  if (window.electron) return
  if (enable) {
    document.documentElement.classList.add("home-screen")
    return
  }
  document.documentElement.classList.remove("home-screen")
}
